import React from "react";
import { Tooltip } from "@mui/material";

const FleetIcon = (props: FleetIconProps) => {
  return (
    <Tooltip
      title={`Skyships: ${props.skyships}
Regiments: ${props.regiments}
Levies: ${props.levies}`}
    >
      <svg
        width="41"
        height="59"
        viewBox="0 0 41 59"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ zIndex: 100 }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5055 1.2218L20.0621 1.14766L18.7321 1.07405L16.8851 1.2218L15.1857 1.66516L13.4124 2.25623L11.8609 2.92114L10.1616 3.80782L8.68386 4.76807L7.28013 6.02409L6.02413 7.20634L4.91559 8.61007L3.80745 10.0878L2.99493 11.7134L2.256 13.4126L1.66479 15.0382L1.29559 16.8113L1.14787 18.6583L1 20.5053L1.14787 22.2787L1.36932 24.1258L1.88666 25.825L2.40373 27.5246L3.21639 29.1498L3.80745 30.1843L15.3335 44.0007H18.6584L10.7527 26.8595L10.3831 25.8991L10.0875 24.9388L9.79199 24.0521L9.57054 23.0913L9.42267 22.0573L9.34906 21.0227L9.27492 19.028L9.42267 17.1067L9.57054 15.1119L9.79199 14.1515L10.0139 13.1909L10.2353 12.1567L10.5309 11.2701L10.8264 10.3834L11.2697 9.34888L11.7131 8.53633L12.2301 7.57593L13.3387 5.95036L13.708 5.43327L14.2253 4.8422L14.8901 4.32475L15.4072 3.80782L16.0724 3.29073L16.7372 2.84741L17.402 2.47782L18.1409 2.03434L18.8061 1.73889L19.6188 1.44328L20.5055 1.2218Z"
          fill={props.colour}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6584 44.0008H20.579V1.22185L19.6188 1.44332L18.8798 1.73894L18.1409 2.03439L17.402 2.47787L16.7372 2.77332L16.1461 3.29078L15.4813 3.80787L14.8901 4.32479L14.2991 4.76811L13.708 5.43331L13.3386 5.87639L12.2301 7.57597L11.7131 8.46224L11.2697 9.34892L10.8264 10.3097L10.5309 11.196L10.3093 12.1568L10.0138 13.1172L9.79197 14.0776L9.57052 15.0383L9.42265 17.1068L9.2749 19.028L9.34904 21.0228L9.42265 22.0573L9.57052 23.0176L9.79197 24.0521L10.0874 24.9388L10.383 25.8992L10.7526 26.8596L11.122 27.8199L18.6584 44.0008Z"
          fill={props.colour}
        />
        <path
          d="M18.6584 44.0008H20.579V1.22185L19.6188 1.44332L18.8798 1.73894L18.1409 2.03439L17.402 2.47787L16.7372 2.77332L16.1461 3.29078L15.4813 3.80787L14.8901 4.32479L14.2991 4.76811L13.708 5.43331L13.3386 5.87639L12.2301 7.57597L11.7131 8.46224L11.2697 9.34892L10.8264 10.3097L10.5309 11.196L10.3093 12.1568L10.0138 13.1172L9.79197 14.0776L9.57052 15.0383L9.42265 17.1068L9.2749 19.028L9.34904 21.0228L9.42265 22.0573L9.57052 23.0176L9.79197 24.0521L10.0874 24.9388L10.383 25.8992L10.7526 26.8596L11.122 27.8199L18.6584 44.0008Z"
          stroke="black"
          strokeWidth="0.999733"
          strokeMiterlimit="22.9256"
        />
        <path
          d="M20.5054 1.14771L21.0223 1H22.2783L24.1258 1.22185L25.8987 1.51746L27.598 2.10852L29.2972 2.77332L30.8491 3.66L32.3266 4.6945L33.7307 5.9504L34.9866 7.20638L36.2426 8.61011L37.2028 10.0141L38.0159 11.6393L38.7548 13.3387L39.3455 14.9642L39.7888 16.7376L40.0107 18.5846V20.3576L39.863 22.1309L39.6411 23.978L39.1978 25.7513L38.607 27.3769L37.868 29.0763L37.277 30.1103L25.6772 44.0008H22.3524L29.5928 28.7065L29.8884 27.6725L30.3318 26.7859L30.7014 25.825L31.0706 24.8647L31.2184 23.978L31.4399 23.0176L31.5876 21.9832L31.7354 21.0228L31.8095 19.028L31.6618 16.9591L31.4399 14.9642L31.2184 14.0039L31.0706 13.0435L30.8491 12.0826L30.5536 11.1224L30.1839 10.3097L29.8147 9.34892L29.2972 8.38863L28.8543 7.50183L27.672 5.80266L27.3766 5.35934L26.1943 4.17705L25.6031 3.73373L25.012 3.21664L24.3472 2.77332L23.6083 2.33L22.9435 1.96078L22.2046 1.66521L21.4658 1.44332L20.5054 1.14771Z"
          stroke="black"
          strokeWidth="0.999733"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 1.14771L20.5169 1H21.7729L23.6204 1.22185L25.3933 1.51746L27.0927 2.10852L28.7919 2.77332L30.3437 3.66L31.8212 4.6945L33.2253 5.9504L34.4812 7.20638L35.7372 8.61011L36.6974 10.0141L37.5105 11.6393L38.2495 13.3387L38.8401 14.9642L39.2835 16.7376L39.5053 18.5846V20.3576L39.3576 22.1309L39.1357 23.978L38.6924 25.7513L38.1016 27.3769L37.3627 29.0763L36.7716 30.1103L25.1719 44.0008H21.8471L29.0875 28.7065L29.3831 27.6725L29.8264 26.7859L30.196 25.825L30.5652 24.8647L30.7131 23.978L30.9345 23.0176L31.0823 21.9832L31.23 21.0228L31.3041 19.028L31.1564 16.9591L30.9345 14.9642L30.7131 14.0039L30.5652 13.0435L30.3437 12.0826L30.0483 11.1224L29.6785 10.3097L29.3093 9.34892L28.7919 8.38863L28.3489 7.50183L27.1667 5.80266L26.8712 5.35934L25.6889 4.17705L25.0977 3.73373L24.5067 3.21664L23.8419 2.77332L23.1029 2.33L22.4381 1.96078L21.6992 1.66521L20.9604 1.44332L20 1.14771Z"
          fill={props.colour}
        />
        <path
          d="M20.5055 1.22188L20.0621 1.14775L18.7321 1.07414L16.8851 1.22188L15.1857 1.66524L13.4124 2.25631L11.8609 2.92123L10.1616 3.8079L8.68386 4.76815L7.28013 6.02417L6.02413 7.20642L4.91559 8.61015L3.80745 10.0879L2.99493 11.7135L2.256 13.4127L1.66479 15.0383L1.29559 16.8114L1.14787 18.6584L1 20.5054L1.14787 22.2788L1.36932 24.1259L1.88666 25.8251L2.40373 27.5247L3.21639 29.1499L3.80745 30.1844L15.3335 44.0008H18.6584L10.7527 26.8596L10.3831 25.8992L10.0875 24.9388L9.79199 24.0522L9.57054 23.0914L9.42267 22.0574L9.34906 21.0228L9.27492 19.028L9.42267 17.1068L9.57054 15.112L9.79199 14.1516L10.0139 13.191L10.2353 12.1568L10.5309 11.2701L10.8264 10.3835L11.2697 9.34896L11.7131 8.53642L12.2301 7.57601L13.3387 5.95044L13.708 5.43335L14.2253 4.84229L14.8901 4.32483L15.4072 3.8079L16.0724 3.29081L16.7372 2.84749L17.402 2.47791L18.1409 2.03443L18.8061 1.73897L19.6188 1.44336L20.5055 1.22188Z"
          stroke="black"
          strokeWidth="0.999733"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.3524 44.0008H20.5054V1.14775L21.4658 1.36963L22.2046 1.66525L22.9435 1.96082L23.6083 2.33004L24.3472 2.77336L24.9383 3.21667L25.6031 3.66003L26.1943 4.17709L26.7854 4.69454L27.3766 5.28561L27.672 5.8027L28.7802 7.50187L29.2972 8.31458L29.7406 9.34896L30.1839 10.2356L30.4795 11.0483L30.7751 12.0091L31.0706 13.0435L31.2184 14.0039L31.4399 14.9643L31.6618 16.9591L31.7354 18.9539V20.9487L31.5876 21.9095L31.4399 22.9436L31.2184 23.9043L31.0706 24.8647L30.7014 25.8251L30.3318 26.7859L29.8884 27.6726L29.5928 28.633L22.3524 44.0008Z"
          fill={props.colour}
        />
        <path
          d="M22.3524 44.0008H20.5054V1.14775L21.4658 1.36963L22.2046 1.66524L22.9435 1.96082L23.6083 2.33004L24.3472 2.77336L24.9383 3.21668L25.6031 3.66004L26.1943 4.17708L26.7854 4.69454L27.3766 5.28561L27.672 5.8027L28.7802 7.50187L29.2972 8.31458L29.7406 9.34896L30.1839 10.2356L30.4795 11.0483L30.7751 12.0091L31.0706 13.0435L31.2184 14.0039L31.4399 14.9643L31.6618 16.9591L31.7354 18.9539V20.9487L31.5876 21.9095L31.4399 22.9436L31.2184 23.9043L31.0706 24.8647L30.7014 25.8251L30.3318 26.7859L29.8884 27.6726L29.5928 28.633L22.3524 44.0008Z"
          stroke="black"
          strokeWidth="0.999733"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.6771 44.0007L24.7905 48.064H16.0722L15.2593 44.0007H25.6771Z"
          fill={props.colour}
        />
        <path
          d="M23.2391 53.3839L23.0913 51.9062V51.1676L22.9435 50.872L22.7958 50.5024L22.6479 50.2068L22.4261 49.9112L21.9091 49.3206L21.5398 49.1727L21.3179 49.0249L21.0223 48.951L20.6531 48.8772H19.7665L19.3969 49.0249L19.1017 49.1727L18.8061 49.3206L18.5842 49.6158L18.3627 49.9112L17.9931 50.4287L17.9194 50.7979L17.8453 51.0935L17.6975 51.4631L17.6238 51.9062L17.5498 52.6449V53.3839H23.2391Z"
          stroke="black"
          strokeWidth="0.999733"
          strokeMiterlimit="22.9256"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3127 53.3838V57.5954H17.5498V53.3838H23.3127Z"
          fill={props.colour}
        />
        <path
          d="M25.6771 44.0007L24.7905 48.064H16.0722L15.2593 44.0007H25.6771Z"
          stroke="black"
          strokeWidth="0.999733"
          strokeMiterlimit="22.9256"
        />
        <path
          d="M23.3127 53.3837V57.5953H17.5498V53.3837H23.3127Z"
          stroke="black"
          strokeWidth="0.999733"
          strokeMiterlimit="22.9256"
        />
      </svg>
    </Tooltip>
  );
};

type FleetIconProps = {
  colour: string;
  skyships: number;
  regiments: number;
  levies: number;
};
export default FleetIcon;
